module.exports = __webpack_public_path__ + "static/media/bgContact.1a636808.png";